import React from 'react';
import { useConsent } from '../store/consent';

// Samme visuelle mønster som InstallBanner.tsx — fast bunn-boks, kort, to knapper.
// Godta/Avslå styrer om AdBanner.tsx faktisk viser en annonse (adsbygoogle.js selv
// lastes uendret i public/index.html, nødvendig for Googles AdSense-verifisering —
// se PersonvernPage.tsx for hvorfor dette er trygt personvernmessig).
export const ConsentBanner: React.FC = () => {
  const { bannerOpen, setAdConsent } = useConsent();

  if (!bannerOpen) return null;

  return (
    <div style={{
      position: 'fixed',
      left: 0, right: 0,
      bottom: 'calc(64px + var(--safe-bottom) + 8px)',
      zIndex: 200,
      padding: '0 12px',
    }}>
      <div style={{
        background: 'var(--surface)',
        border: '1px solid var(--border)',
        borderRadius: 'var(--radius)',
        padding: '14px 16px',
        boxShadow: '0 4px 24px rgba(0,0,0,0.14)',
        maxWidth: 460,
        margin: '0 auto',
      }}>
        <p style={{ fontSize: 14, fontWeight: 600, color: 'var(--text)', marginBottom: 6, lineHeight: 1.4 }}>
          🍪 Annonsecookies
        </p>
        <p style={{ fontSize: 14, color: 'var(--text2)', marginBottom: 14, lineHeight: 1.5 }}>
          Vi kan vise annonser fra Google i appen. Godtar du dette, kan Google sette annonsecookies for å vise relevante annonser. Se Personvern for detaljer.
        </p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={() => setAdConsent('denied')} style={dismissStyle}>Avslå</button>
          <button onClick={() => setAdConsent('granted')} style={acceptStyle}>Godta</button>
        </div>
      </div>
    </div>
  );
};

const dismissStyle: React.CSSProperties = {
  background: 'none',
  border: '1px solid var(--border-strong)',
  borderRadius: 999,
  padding: '8px 18px',
  fontSize: 14,
  fontWeight: 500,
  color: 'var(--text2)',
  cursor: 'pointer',
};

const acceptStyle: React.CSSProperties = {
  background: 'var(--green)',
  border: 'none',
  borderRadius: 999,
  padding: '8px 18px',
  fontSize: 14,
  fontWeight: 600,
  color: '#fff',
  cursor: 'pointer',
};
